import axios, { HttpStatusCode } from "axios"
import { InvalidCredentialsError } from "../errors/authErrors";
import { MissingDataError } from "../errors/genericErrors";

//TODO - Add Error Cases
export default class StaffApi {
  static getStaffMember = async () => {
    try {
      const res = await axios.get("/api/staffMembers/info");
      return res.data;
    }
    catch (error) {
      console.error("Get Staff Member error:", error.response?.data);
      // switch(error.response.status) {
      // }
    }
  }
}